module.exports = __webpack_public_path__ + "img/Bääh.f00bb05b.jpg";